// src/hooks/useOnScreen.ts
import { useState, useEffect, RefObject } from "react";

export function useOnScreen(ref: RefObject<HTMLElement>, rootMargin = "0px") {
  const [isIntersecting, setIntersecting] = useState(false);

  useEffect(() => {
    const current = ref.current;
    if (!current) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIntersecting(true);
          observer.unobserve(current); // animate only once
        }
      },
      { rootMargin }
    );

    observer.observe(current);

    return () => {
      if (current) observer.unobserve(current);
    };
  }, [ref, rootMargin]);

  return isIntersecting;
}
